/* Stroke-based icon path registry for <CwIcon>.
   Paths sourced from Collabware design handoff (designs/mainapp/icons.jsx).
   All icons assume 20x20 viewBox and inherit stroke from currentColor. */

export const iconPaths = {
    dashboard: (
        <path d="M3 3h6v8H3zM11 3h6v5h-6zM3 13h6v4H3zM11 10h6v7h-6z" />
    ),
    tenants: (
        <>
            <path d="M4 17V8l6-4 6 4v9" />
            <path d="M8 17v-5h4v5" />
        </>
    ),
    users: (
        <>
            <circle cx="7" cy="8" r="3" />
            <path d="M2 17c0-2.8 2.2-5 5-5s5 2.2 5 5" />
            <circle cx="14" cy="7" r="2.5" />
            <path d="M12 17c0-2.8 2-5 5-5" />
        </>
    ),
    apps: (
        <>
            <rect x="3" y="3" width="6" height="6" rx="1" />
            <rect x="11" y="3" width="6" height="6" rx="1" />
            <rect x="3" y="11" width="6" height="6" rx="1" />
            <rect x="11" y="11" width="6" height="6" rx="1" />
        </>
    ),
    licensing: (
        <>
            <path d="M4 4h9l4 4v8a2 2 0 01-2 2H4z" />
            <path d="M13 4v4h4" />
            <path d="M7 12h6M7 15h4" />
        </>
    ),
    audits: (
        <>
            <rect x="3" y="4" width="14" height="13" rx="1.5" />
            <path d="M6 8h8M6 11h8M6 14h5" />
        </>
    ),
    analytics: <path d="M3 17V9M8 17V5M13 17v-6M18 17V8" />,
    diagnostics: <path d="M3 10h3l2-5 4 10 2-5h3" />,
    settings: (
        <>
            <circle cx="10" cy="10" r="2.5" />
            <path d="M10 3v2M10 15v2M3 10h2M15 10h2M5.2 5.2l1.4 1.4M13.4 13.4l1.4 1.4M5.2 14.8l1.4-1.4M13.4 6.6l1.4-1.4" />
        </>
    ),
    billing: (
        <>
            <rect x="2.5" y="5" width="15" height="10" rx="1.5" />
            <path d="M2.5 9h15M6 13h3" />
        </>
    ),
    chevron: <path d="M7 4l5 6-5 6" />,
    'chevron-left': <path d="M13 4l-5 6 5 6" />,
    'chevron-right': <path d="M7 4l5 6-5 6" />,
    'chevron-down': <path d="M4 7l6 5 6-5" />,
    sun: (
        <>
            <circle cx="10" cy="10" r="3" />
            <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.5 4.5l1.4 1.4M14.1 14.1l1.4 1.4M4.5 15.5l1.4-1.4M14.1 5.9l1.4-1.4" />
        </>
    ),
    moon: <path d="M15 11.5A6 6 0 018.5 5a6 6 0 105.7 7.5 6 6 0 01.8-1z" />,
    plus: <path d="M10 4v12M4 10h12" />,
    invite: (
        <>
            <rect x="3" y="5" width="14" height="10" rx="1.5" />
            <path d="M3 6l7 5 7-5" />
        </>
    ),
    doc: (
        <>
            <path d="M5 3h7l4 4v10a1 1 0 01-1 1H5z" />
            <path d="M12 3v4h4" />
        </>
    ),
    arrow: <path d="M4 10h11M11 6l4 4-4 4" />,
    search: (
        <>
            <circle cx="9" cy="9" r="5" />
            <path d="M13 13l4 4" />
        </>
    ),
    shield: (
        <>
            <path d="M10 3l6 2v5c0 4-3 6.5-6 7-3-.5-6-3-6-7V5z" />
            <path d="M7.5 10l1.8 1.8L13 8" />
        </>
    ),
    package: (
        <>
            <path d="M10 3l7 3.5v7L10 17 3 13.5v-7z" />
            <path d="M3 6.5L10 10l7-3.5M10 10v7" />
        </>
    ),
    close: <path d="M5 5l10 10M15 5L5 15" />,
    copy: (
        <>
            <rect x="7" y="7" width="10" height="10" rx="1.5" />
            <path d="M3 13V4.5A1.5 1.5 0 014.5 3H13" />
        </>
    ),
    check: <path d="M4 10.5L8 14.5L16 6.5" />,
    health: (
        <path d="M17 10h-3l-2-5-4 10-2-5H3" />
    ),
    integrations: (
        <>
            <circle cx="6" cy="6" r="2.5" />
            <circle cx="14" cy="6" r="2.5" />
            <circle cx="10" cy="14" r="2.5" />
            <path d="M7 8l2 4M13 8l-2 4" />
        </>
    ),
};
